import { Button } from "@/components/ui/button/button";
import { BwTitleCaseLine } from "@/components/ui/icons";

export function ToggleInlineMenuButton({
  toggleInlineMenu,
}: {
  toggleInlineMenu: () => void;
}) {
  return (
    <Button
      data-test="text-editor-button"
      kind="ghost"
      variant="neutral"
      size="icon-sm"
      onClick={() => toggleInlineMenu()}
    >
      <BwTitleCaseLine />
    </Button>
  );
}
